<template>
  <div class="app-container-head">
    <slot></slot>
    <div v-if="projectName || tip" class="project-name">
      {{ projectName }}
      <span v-if="tip" class="tip m-l-8">{{ tip }}</span>
    </div>
    <slot name="other"></slot>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * 名称
     */
    projectName: {
      type: String,
      default: ''
    },

    tip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container-head {
  background: $white-background-color;
  border: 1px solid $info-fourth-color;
  padding: 16px;

  .project-name {
    margin-top: 22px;
    margin-bottom: 8px;
    font-size: 20px;
    @include text-bold;
    line-height: 28px;
    color: $text-color;

    .tip {
      font-size: 14px;
      font-weight: normal;
      color: $third-text-color;
    }
  }
}
</style>
